const waAccounts = [
    // {
    //     waba_id: '607924193270410',
    //     phone_number_id: '2781159621959898',
    //     display_phone_number: '919539539453',
    //     business_name: 'Customer Care'
    // },
    {
        waba_id: '587619491098352',
        phone_number_id: '1269933292863371',
        display_phone_number: '918714799953',
        business_name: 'Cloud API'
    }
]




module.exports = {
    waAccounts
};